import ServiceHeader from '@mos-front-components/public/es/components/ServiceHeader/ServiceHeader';
import { RouterAPI } from 'dva';
import { Route, routerRedux, Switch } from 'dva/router';
import React, { useEffect } from 'react';
import acs from '@mos-utils/acs';
import { useAuthorizationStatus } from '@mos-utils/acs-react';
import * as Sentry from '@sentry/react';

import AboutServiceContent from './components/layout/AboutContent/AboutContent';
import Providers from './components/layout/Providers/Providers';
import breadcrumbs from './config/breadcrumbs';
import FormPage from './pages/FormPage/FormPage';
import MainPage from './pages/MainPage';
import ResultPage from './pages/ResultPage';
import { basename } from './setup';

const { ConnectedRouter } = routerRedux;

export const RouterComponent = ({ history }) => {
  const value = useAuthorizationStatus();

  useEffect(() => {
    const backUrl =
      value === 'authorized'
        ? `${window.location.origin}${basename}`
        : window.location.href;
    acs.configure({
      backUrl,
    });
  }, [value]);
  return (
    <ConnectedRouter history={history}>
      <div className="App">
        <Route
          path="/"
          children={({ location }: { location: Location }) => (
            <ServiceHeader
              breadcrumbsData={{
                breadcrumbs: breadcrumbs(location.pathname),
              }}
              aboutServiceData={{
                titleToggle: 'Об услуге',
                titleWindow: '',
                titleCloseBtn: 'Скрыть',
                content: <AboutServiceContent />,
              }}
            />
          )}
        />
        <Switch>
          <Route exact path="/" component={MainPage} />
          <Route exact path="/new/" component={FormPage} />
          <Route
            path="/error/"
            component={(props) => <ResultPage {...props} />}
          />
          <Route path="/success/" component={ResultPage} />
          <Route path="/queue/" component={ResultPage} />
        </Switch>
      </div>
    </ConnectedRouter>
  );
};

export function router({ history }: RouterAPI): JSX.Element {
  return (
    <Sentry.ErrorBoundary
      fallback={<p>Сервис временно недоступен, попробуйте позже</p>}
    >
      <Providers>
        <RouterComponent history={history} />
      </Providers>
    </Sentry.ErrorBoundary>
  );
}
